import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TYPES } from "./calUtils";

const sel = "border rounded-full h-9 px-3 text-sm bg-white max-w-[180px]";

export function CalendarFilters({ items, filters, setFilters, showPeople }) {
  const uniq = (pairs) => Object.entries(Object.fromEntries(pairs.filter(([id, n]) => id && n))).sort((a, b) => a[1].localeCompare(b[1]));
  const dancers = uniq(items.flatMap((i) => (i.dancer_ids || []).map((id, k) => [id, (i.dancer_names || [])[k]])));
  const teachers = uniq(items.flatMap((i) => (i.teacher_ids || []).map((id, k) => [id, (i.teacher_names || [])[k] || (id === i.sub_teacher_id ? i.sub_teacher_name : "")])));
  const classes = uniq(items.filter((i) => i.class_id && i.class_name).map((i) => [i.class_id, i.class_name]));
  const rooms = [...new Set(items.map((i) => i.location).filter(Boolean))].sort();
  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="calendar-filters">
      <select data-testid="cal-filter-type" aria-label="Event type" className={sel} value={filters.type} onChange={set("type")}>
        <option value="">All event types</option>{Object.entries(TYPES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
      </select>
      {dancers.length > 1 && <select data-testid="cal-filter-dancer" aria-label="Dancer" className={sel} value={filters.dancer} onChange={set("dancer")}>
        <option value="">All dancers</option>{dancers.map(([id, n]) => <option key={id} value={id}>{n}</option>)}
      </select>}
      {classes.length > 1 && <select data-testid="cal-filter-class" aria-label="Class" className={sel} value={filters.cls} onChange={set("cls")}>
        <option value="">All classes</option>{classes.map(([id, n]) => <option key={id} value={id}>{n}</option>)}
      </select>}
      {showPeople && teachers.length > 1 && <select data-testid="cal-filter-teacher" aria-label="Teacher or choreographer" className={sel} value={filters.teacher} onChange={set("teacher")}>
        <option value="">All teachers</option>{teachers.map(([id, n]) => <option key={id} value={id}>{n}</option>)}
      </select>}
      {rooms.length > 1 && <select data-testid="cal-filter-room" aria-label="Studio" className={sel} value={filters.room} onChange={set("room")}>
        <option value="">All studios</option>{rooms.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>}
      {active && <Button size="sm" variant="ghost" className="rounded-full h-9" data-testid="cal-filter-clear" onClick={() => setFilters({ type: "", dancer: "", cls: "", teacher: "", room: "" })}><X className="w-4 h-4 mr-1" />Clear</Button>}
    </div>);
}

export function applyFilters(items, f, scopeMine) {
  return items.filter((i) => {
    if (i.type === "holiday") return !f.type || f.type === "holiday";
    if (f.type && i.type !== f.type) return false;
    if (scopeMine && !i.mine && !["event", "recital", "performance"].includes(i.type)) return false;
    if (f.dancer && !(i.dancer_ids || []).includes(f.dancer)) return false;
    if (f.cls && i.class_id !== f.cls) return false;
    if (f.teacher && !(i.teacher_ids || []).includes(f.teacher)) return false;
    if (f.room && i.location !== f.room) return false;
    return true;
  });
}
